// extracted by mini-css-extract-plugin
module.exports = {"waterWave":"waterWave_1cNuB","text":"text_3FuaL","waterWaveCanvasWrapper":"waterWaveCanvasWrapper_11qyj"};